module.exports = __webpack_public_path__ + "icon-facebook.png?821f7660112c2f5d6f56e019863cc765";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-facebook.png
// module id = 243
// module chunks = 0